@if (properties && !showInitialCaptcha) {
  <div class="form-group label-static"
       [ngClass]="{'is-focused': $any(input)?.isFocused, 'input--filled': formControl.dirty, 'has-error': formErrors?.error }">
    <label class="control-label">
      <span>{{ 'generic.password' | translate }}</span>
    </label>
    <input class="form-control"
           [formControl]="formControl"
           required
           type="password"
           autocomplete="new-password"
           #input appFocusable (onFocusChange)="$any(input).isFocused = $event">
  </div>
  @if (formErrors?.error) {
    <app-input-errors
        translationKey="errors.login"
        [errorsForField]="formErrors"/>
  }

  @if (isPasswordFlow(PASSWORD_FLOW.OWN)) {
    @if (!isSendingPassword) {
      @if (!triedToSendPassword) {
        <a (click)="sendPassword(PASSWORD_FLOW.OWN)">
          {{ 'login.password-input.' + getSendPasswordType() + '_password' | translate }}
        </a>
      }
      @if (triedToSendPassword && hasSendPasswordSuccess) {
        <a (click)="sendPassword(PASSWORD_FLOW.OWN)">
          {{ 'login.password-input.' + getSendPasswordType() + '_password_success' | translate }}
        </a>
      }
      @if (triedToSendPassword && !hasSendPasswordSuccess) {
        <a (click)="sendPassword(PASSWORD_FLOW.OWN)">
          {{ 'login.password-input.' + getSendPasswordType() + '_password_errored' | translate }}
        </a>
      }
    } @else {
      <a>{{ 'login.password-input.sending_' + getSendPasswordType() + '_password' | translate }}</a>
    }
  }
  @if (isPasswordFlow(PASSWORD_FLOW.SEND_THROUGH_SMS)) {
    <div class="send-password-wrapper">
      @if (showResendCaptcha) {
        <app-password-resend-captcha
            (captchaFinished)="resendCaptchaFinished($event)"/>
      }
      @if (!isSendingPassword && !showResendCaptcha) {
        @if (hasSendPasswordSuccess) {
          <span>{{ 'generic.password_sent_status' | translate }}</span>
        }
        @if (!hasSendPasswordSuccess) {
          <span>{{ 'members.send_password.error_message' | translate }}</span>
        }
        <a class="underline" (click)="sendPassword(PASSWORD_FLOW.SEND_THROUGH_SMS, true)">
          <span>{{ 'generic.resend_password_click_here' | translate }}</span>
        </a>
      }
      @if (isSendingPassword) {
        <span>{{ 'generic.sending_password' | translate }}</span>
      }
    </div>
  }
}
@if (showInitialCaptcha) {
  <div>
    <app-recaptcha (data)="initialCaptchaFinished($event)"/>
  </div>
}
